export default __webpack_public_path__ + "static/media/vip-5.18563d94.webp";